// extracted by mini-css-extract-plugin
export var Abstract = "index-module--Abstract--XVIQf";
export var ClientBody = "index-module--ClientBody--17unQ";
export var ClientContent = "index-module--ClientContent--TKsRW";
export var Type20211220 = "index-module--Type20211220--wTewS";